
@use '@css/variables';


.container{
  display: grid;
  gap: 1em;
  grid-template-columns: repeat(1, 1fr);

  & > div {
    background-color: white;
    border-radius: var(--border-radius);
    padding: 1em;

    // push the button down
    display: flex;
    flex-direction: column;
  }

  .content {
    margin: 1em 0;
    flex-grow: 1;
  }

  dl {
    display: grid;
    grid-gap: 0.3em 1em;
    grid-template-columns: max-content;

    dt {
      color: var(--beigedarker);
    }
    dd {
      margin: 0;
      grid-column-start: 2;
    }
  }

  a {
    width: 100%;
    justify-content: center;
  }

}


@media only screen and (min-width: variables.$lg-breakpoint) {
  .container{
    grid-template-columns: repeat(2, 1fr);
  }
}
